module.exports = __webpack_public_path__ + "static/img/17069D_1_2_C_20210326_fit.cfe0600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17069D_1_2_C_20210326_fit.png
// module id = uU3W
// module chunks = 0